import {SET_CONFIG} from 'state/actions';

export default function configReducer(state = null, action) {
  switch (action.type) {
    case SET_CONFIG:
      return action.config;
    default:
      return state;
  }
}
